(() => {
  const { currency, storeCurrency, moneyStep } = document.documentElement.dataset;
  const step = Number(moneyStep) || 1;
  const fallback = 'Shipping calculated at checkout';

  // Settings are base-currency amounts. Shopify supplies its active Markets FX rate.
  // US thresholds are fixed USD amounts and must bypass GBP conversion/catalog pricing.
  function amount(element) {
    const base = Number(element.dataset.shippingBaseAmount);
    const source = element.dataset.shippingBaseCurrency;
    if (!Number.isFinite(base) || base <= 0) return null;
    let rate = 1;
    if (source !== currency) {
      rate = Number(window.Shopify?.currency?.rate);
      if (source !== storeCurrency || window.Shopify?.currency?.active !== currency || !Number.isFinite(rate) || rate <= 0) return null;
    }
    return Math.ceil(base * 100 * rate / step - 1e-8) * step;
  }

  function update(goal, total) {
    goal.dataset.shippingTotal = total;
    const threshold = amount(goal);
    const message = goal.querySelector('[data-shipping-message]');
    const track = goal.querySelector('[role="progressbar"]');
    if (track) track.hidden = threshold === null;
    if (threshold === null) {
      if (message) message.textContent = fallback;
      return;
    }
    const remaining = Math.max(0, threshold - total);
    if (message) message.textContent = remaining
      ? goal.dataset.remaining.replace('[amount]', window.VelvetMoney.format(remaining))
      : goal.dataset.unlocked;
    const progress = Math.min(100, total / threshold * 100);
    const bar = goal.querySelector('[data-shipping-progress], [data-shipping-bar]');
    if (bar) bar.style.width = `${progress}%`;
    track?.setAttribute('aria-valuenow', String(Math.round(progress)));
    if (goal.classList.contains('cart-page-shipping')) goal.classList.toggle('is-unlocked', remaining === 0);
  }

  const selector = '[data-shipping-amount], [data-shipping-goal], [data-box-shipping], [data-cart-shipping]';
  function hydrate(root) {
    const elements = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) elements.unshift(root);
    for (const element of elements) {
      if (element.hasAttribute('data-shipping-amount')) {
        const cents = amount(element);
        element.textContent = cents === null ? fallback : window.VelvetMoney.format(cents);
      } else update(element, Number(element.dataset.shippingTotal) || 0);
    }
  }

  window.VelvetShipping = { amount, update, hydrate };
  hydrate(document);
  document.addEventListener('shopify:section:load', event => hydrate(event.target));
  // Cart section replacements and the customizer insert fresh Liquid markup.
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) if (node.nodeType === 1) hydrate(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
